import { Pipe, PipeTransform } from '@angular/core';
import { formatDataHoraBr } from '@utils/date.utils';

@Pipe({
  name: 'dataHoraFormatted',
})
export class DataHoraFormattedPipe implements PipeTransform {
  transform(dataHora: string | undefined): string {
    return formatDataHoraBr(dataHora);
  }
}
